<template>
  <div class="group-management-container">
    <div class="menu-router-container">
      <third-router-nav />
      <div class="simple-menu-right">
        <el-button type="success" icon="el-icon-plus" @click="addUser">
          新增
        </el-button>
      </div>
    </div>
    <div v-loading="loading" class="menu-stores">
      <div class="stores-contain">
        <div class="simple-menu">
          <simple-search :search-data="searchData" :is-unwind="false" @child-event="getSearch" @child-close="getReset" />
        </div>
        <div class="user-table">
          <table-people
            :table-data="tableData"
            :table-headers="tableHeaders"
            :is-page="true"
            :border="false"
            :total="total"
            :page="current"
            :page-size="size"
            :page-sizes="[5, 10, 25, 50, 100]"
            :page-background="false"
            page-layout="total, sizes, prev, pager, next, jumper"
            page-position="right"
            @currentPage="currentPage"
            @sizeChange="sizeChange"
          >
            <template slot="adminUserList" slot-scope="scope">
              <p v-for="(item, index) in scope.row.adminUserList" :key="index">
                {{ item.nickName }}
              </p>
            </template>
            <template slot="options" slot-scope="scope">
              <div class="operation">
                <div class="operation-btn edit-btn" @click="goEdit(scope.row)">
                  编辑
                </div>
                <div class="operation-btn-delete" @click="goDel(scope.row.id)">
                  删除
                </div>
              </div>
            </template>
          </table-people>
        </div>
      </div>
    </div>
    <popup title="提示" :show.sync="show" :content="popupContent" confirm-button-text="确 定" background="#FF645F" @toTrue="toTrue" />
    <subsidiary-form ref="miniprogramForm" @fresh="getReset" />
  </div>
</template>

<script>
import SimpleSearch from '@/components/search/SimpleSearch'
import TablePeople from '@/components/table/TablePeople'
import Popup from '@/components/popup/Popup'
import ThirdRouterNav from '@/components/dashboard/ThirdRouterNav'
import SubsidiaryForm from './subsidiary-form'
import { sysCompanyPage, deleteSysCompany } from '@/api/index'
export default {
  components: {
    SimpleSearch,
    TablePeople,
    Popup,
    ThirdRouterNav,
    SubsidiaryForm
  },
  data() {
    return {
      loading: false,
      searchData: [
        { name: '公司名称', field: 'companyName', type: 'text' }
      ],
      size: 10,
      current: 1,
      total: 0,
      tableHeaders: [
        { prop: 'companyName', label: '公司名称', options: [{ type: 'sort' }] },
        { prop: 'adminUserList', label: '管理员名称', options: [{ type: 'sort' }] },
        { prop: 'options', label: '操作', width: 200 }
      ],
      tableData: [],
      show: false,
      popupContent: '',
      userId: '',
      searchParams: {}
    }
  },
  mounted() {
    this.getSysCompanyPage()
  },
  methods: {
    getSysCompanyPage() {
      this.loading = true
      const data = {
        current: this.current,
        size: this.size,
        ...this.searchParams
      }
      sysCompanyPage(data).then((res) => {
        this.loading = false
        if (res.code === 0) {
          console.log(res.data)
          this.total = res.data.total
          this.tableData = res.data.records
        }
        // 在删除时候判断
        if (this.total > 0 && this.current > 1 && this.tableData.length === 0) {
          this.current -= 1
          this.getSysCompanyPage()
        }
      }).finally(result => {
        this.loading = false
      })
    },
    /**
     * 删除接口
     * */
    getDeleteSysCompany() {
      deleteSysCompany(this.userId).then((res) => {
        if (res.code === 0) {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getSysCompanyPage()
        } else {
          this.$message.error('删除失败')
        }
      })
    },
    // 查询
    getSearch(data) {
      this.current = 1
      this.size = 10
      const param = {}
      Object.keys(data).map(key => {
        data[key] && (param[key] = data[key])
      })
      this.searchParams = param
      this.getSysCompanyPage()
    },
    // 重置
    getReset() {
      this.current = 1
      this.size = 10
      this.searchParams = {}
      this.getSysCompanyPage()
    },
    // 分页页数改变
    currentPage(page) {
      this.current = page
      this.getSysCompanyPage()
    },
    /**
       * 分页大小改变
       * */
    sizeChange(size) {
      this.size = size
      this.getSysCompanyPage()
    },
    // 详情
    goDetail(id) {
      console.log(id)
    },
    // 新增
    addUser() {
      this.$refs.miniprogramForm.init()
    },
    // 编辑
    goEdit(row = {}) {
      this.$refs.miniprogramForm.init(row)
      console.log(row)
    },
    // 白名单
    goDisable() {
      this.$router.push({
        path: `/whitelist`
      })
    },
    // 删除
    goDel(id) {
      this.popupContent = '是否删除？'
      this.show = true
      this.userId = id
    },
    // 点击确定弹窗
    toTrue() {
      this.show = false
      this.getDeleteSysCompany()
    }
  }
}
</script>

<style lang="scss" scoped>
  .group-management-container {
    background-color: #fff;
    width: 100%;
    flex: 1;
    .menu-router-container {
      display: flex;
      justify-content: space-between;
      background-color: #ebeeef;
      .simple-menu-right {
        width: 200px;
        margin-right: 40px;
        display: flex;
        justify-content: flex-end;
        .el-button {
          height: 32px;
          line-height: 32px;
          padding: 0 10px;
          margin-left: 15px;
        }
      }
    }
    .menu-stores {
      padding: 20px;
    }
    .user-table {
      width: 100%;
      margin-top: 30px;
      .disable-btn {
        color: #999999;
      }
      .edit-btn {
        color: #E6A23C;
      }
      .del-btn {
        color: #FF3939;
      }
    }
  }
</style>
